import * as React from "react";
const SvgGreenEuro = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={31}
    height={31}
    fill="none"
    {...props}
  >
    <path
      stroke="#389C7B"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.25}
      d="M15.015 28.905c7.671 0 13.89-6.219 13.89-13.89s-6.219-13.89-13.89-13.89-13.89 6.219-13.89 13.89 6.219 13.89 13.89 13.89"
    />
    <path
      stroke="#389C7B"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.25}
      d="M13.984 16.515c-.937 2.188-2.343 4.375-4.218 5.25h8.906s1.406 0 2.344-.875m-3.75-4.375h-8.25m10.5-4.125a4.125 4.125 0 1 0-4.125 4.125"
    />
  </svg>
);
export default SvgGreenEuro;
